import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { errorHandler } from "@gtpl/shared-utils/error-messages";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { HamletResponseModel } from "./dto/hamlet-response.model";
import { HamletDto } from "./dto/hamlet.dto";
import { HamletEntity } from "./hamlet.entity";

@Injectable()
export class HamletService { 
    constructor (
        @InjectRepository(HamletEntity)
        private readonly hmRepo:Repository<HamletEntity>,
    ){}

    async createNew(sDto: HamletDto, request:Request): Promise<HamletResponseModel> {
        const response = new HamletResponseModel();        
        try {
            const checkExe = await this.hmRepo.findOne();  
            if(checkExe) { 
                throw new ErrorResponse(99998, 'record alredy existed! ')
            }            
            const saveData = await this.hmRepo.save(sDto);
            if(saveData) {
                response.status = true;
                response.data   = saveData;
                response.statusCode = 50000;
                response.internalMessage = 'saved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'save failed')
            }            
            return response;
        } catch (error) {
            return errorHandler(HamletResponseModel, error);
        }
    }

    async updateOld(sDto: HamletDto, request:Request): Promise<HamletResponseModel> {
        const response = new HamletResponseModel();        
        try {
            const checkExe = await this.hmRepo.findOne();  
            if(checkExe) {                 
                   const updated = await this.hmRepo.update(sDto.Id, sDto);
                    response.status = true;
                    response.data   = updated;
                    response.statusCode = 50000;
                    response.internalMessage = 'updated successfully';
                    response.intlCode = 11108;
               response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'update failed')
            }            
            return response;
        } catch (error) {
            return errorHandler(HamletResponseModel, error);
        }
    }

    async getdata():Promise<HamletResponseModel> {
        const response = new HamletResponseModel();
        try {
            const data = await this.hmRepo.find({
                relations:['village'],
                where:{status:true}});
            if(data) {
                response.status = true;
                response.data   = data;
                response.statusCode = 50000;
                response.internalMessage = 'data retrived successfully';
                response.intlCode = 11108;
            } else { 
                throw new ErrorResponse(99998, 'data not found')
            }            
            return response;           
        } catch (error) {
            return errorHandler(HamletResponseModel, error);
        }
    }

    async getAllByVillageId(vId):Promise<HamletResponseModel> {
        const response = new HamletResponseModel();
        try {
            const data = await this.hmRepo.find({
                relations:['village'],
                where:{villageId:vId,status:true}});
            if(data) {
                response.status = true;
                response.data   = data;
                response.statusCode = 50000;
                response.internalMessage = 'data retrived successfully';
                response.intlCode = 11108;
            } else { 
                throw new ErrorResponse(99998, 'data not found')
            }            
            return response;           
        } catch (error) {
            return errorHandler(HamletResponseModel, error);
        }
    }
}